import { ConsentType, ConsentPermission } from 'app/area/user-profile/my-notifications/types';

export const isChannelActive = (type: ConsentType, permission: ConsentPermission): boolean => {
  const conf = {
    [ConsentType.sms]: permission.sms
  };

  return conf[type];
};
